import { Route, Routes, BrowserRouter } from "react-router-dom";
import Start from "./Components/Pages/Start";
import ValueProposition from "./Components/Pages/Consent/ValueProposition";
import DataSharingInstructions from "./Components/Pages/Consent/DataSharingInstructions";
import DataRequest from "./Components/Pages/Consent/DataRequest";
import SelectDataHolder from "./Components/Pages/Consent/SelectDataHolder";

import DhAuth from "./Components/Pages/Consent/DhAuth";
import DhAuthCallBack from "./Components/Pages/Consent/DhAuthCallBack";
import DashboardLanding from "./Components/Pages/Withdraw/DashboardLanding/DashboardLanding";
import DataSharingArrangement from "./Components/Pages/Withdraw/DataSharingArrangement";
import ReviewWithdraw from "./Components/Pages/Withdraw/ReviewWithdraw";
import WithdrawalSuccess from "./Components/Pages/Withdraw/WithdrawalSuccess";
import End from "./Components/Pages/End";
import ScrollToTop from "./ScrollToTop";

import SelectCustomer from "./Components/Pages/MockBank/SelectCustomer";
import OneTimePassword from "./Components/Pages/MockBank/OneTimePassword";
import SelectAccounts from "./Components/Pages/MockBank/SelectAccounts";
import RequireAuth from "./navigation/RequireAuth";
import { NotFound } from "./Components/Result/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route index element={<Start />} />
          <Route path="*" element={<NotFound />} />
          {/* consent */}
          <>
            <Route
              path="/ValueProposition"
              element={
                <RequireAuth>
                  <ValueProposition />
                </RequireAuth>
              }
            />
            <Route
              path="/DataRequest"
              element={
                <RequireAuth>
                  <DataRequest />
                </RequireAuth>
              }
            />

            <Route
              path="/DataSharingInstructions"
              element={
                <RequireAuth>
                  <DataSharingInstructions />
                </RequireAuth>
              }
            />

            <Route
              path="/SelectDataHolder"
              element={
                <RequireAuth>
                  <SelectDataHolder />
                </RequireAuth>
              }
            />

            <Route
              path="/DhAuth"
              element={
                <RequireAuth>
                  <DhAuth />
                </RequireAuth>
              }
            />

            <Route
              path="/DhAuthCallBack"
              element={
                <RequireAuth>
                  <DhAuthCallBack />
                </RequireAuth>
              }
            />
            <Route
              path="/end"
              element={
                <RequireAuth>
                  <End />
                </RequireAuth>
              }
            />
          </>
          {/* mock */}
          <>
            <Route
              path="/SelectCustomer"
              element={
                <RequireAuth>
                  <SelectCustomer />
                </RequireAuth>
              }
            />
            <Route
              path="/OneTimePassword"
              element={
                <RequireAuth>
                  <OneTimePassword />
                </RequireAuth>
              }
            />
            <Route
              path="/SelectAccounts"
              element={
                <RequireAuth>
                  <SelectAccounts />
                </RequireAuth>
              }
            />
          </>
          {/* manage */}
          <>
            <Route
              path="/DashboardLanding"
              element={
                <RequireAuth>
                  <DashboardLanding />
                </RequireAuth>
              }
            />
            <Route
              path="/DataSharingArrangement/:consentId"
              element={
                <RequireAuth>
                  <DataSharingArrangement />
                </RequireAuth>
              }
            />
            <Route
              path="/ReviewWithdraw/:consentId"
              element={
                <RequireAuth>
                  <ReviewWithdraw />
                </RequireAuth>
              }
            />
            <Route
              path="/WithdrawalSuccess/:consentId"
              element={
                <RequireAuth>
                  <WithdrawalSuccess />
                </RequireAuth>
              }
            />
          </>
        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
}
